export const dialogBackground= 'rgb(218, 226, 240)'
export const dialogBorderColor= '‫‪#7b241c'
export const dialogContentColor= 'gray'
export const dialogContentTextColor= '#ffffff'

export const avatarDialogBackgroundColor= 'rgb(177, 196, 227)'
export const avatarDialogContentColor= 'rgb(177, 196, 227)'

